<div>
    <div class="db-login-2fa">
      <div class="db-login-2fa-header">
        <div class="db-login-header-title">{{'text_login2faTitle' | dbText}}</div>
        <div class="db-login-header-desc"><span [innerHtml]="'text_login2faDesc' | dbText"></span></div>
      </div>
      <form [formGroup]="login2faForm" (keydown)="keyDownFunction($event)">
        <div class="db-login-2fa-body" *ngIf="activeBlock === 'google-authenticator'">
          <div class="db-login-body-label">{{'text_disable2faLabelAuthenticator' | dbText}}</div>
          <input class="db-fc-input login2faCode" name="login2faCode" placeholder="Enter a Code" [style.border-color]="(login2faForm.controls['login2faCode'].invalid && ((login2faForm.controls['login2faCode'].touched && !login2faForm.controls['login2faCode'].errors['required']) || formSubmitted) || (serverErrors && serverErrors.message)) ? '#E95E5B' : null" formControlName="login2faCode"/>
        </div>
        <div class="db-login-2fa-body" *ngIf="activeBlock === 'google-recovery'">
          <div class="db-login-body-label">{{'text_disable2faLabelRecovery' | dbText}}</div>
          <input class="db-fc-input login2faCode" name="login2faCode" placeholder="Enter a Recovery Code" [style.border-color]="(login2faForm.controls['login2faCode'].invalid && ((login2faForm.controls['login2faCode'].touched && !login2faForm.controls['login2faCode'].errors['required']) || formSubmitted) || (serverErrors && serverErrors.message)) ? '#E95E5B' : null" formControlName="login2faCode"/>
        </div>
        <div class="db-server-error-wrap">
          <div *ngIf="(login2faForm.controls['login2faCode'].invalid && ((login2faForm.controls['login2faCode'].touched && !login2faForm.controls['login2faCode'].errors['required']) || formSubmitted)) && !(serverErrors && serverErrors.fields)">{{'text_empty2fa' | dbText}}</div>
          <div *ngIf="(serverErrors && serverErrors.fields && serverErrors.fields['2fa_token'])">{{serverErrors?.fields['2fa_token'] && serverErrors.fields['2fa_token'][0]}}</div>
          <div *ngIf="(serverErrors && !serverErrors.fields['2fa_token'])">{{serverErrors.message}}</div>
        </div>
      </form>
      <div class="db-login-2fa-button">
        <a class="db-button db-button_info" (click)="onSubmit()"  [ngClass]="{'db-button_disabled': loading || login2faForm.controls['login2faCode'].invalid}">
          <span *ngIf="!loading">Verify</span>
          <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
        </a>
      </div>
    </div>
    <div class="db-login-2fa-footer">
      <div *ngIf="activeBlock === 'google-authenticator'" (click)="changeBlock()">
        <div class="db-login-2fa-footer-icon">
          <i class="db-icon db-icon-recovery"></i>
        </div>
        <div class="db-login-2fa-footer-text">
          <div class="db-login-2fa-footer-text-title">{{'text_disable2faTroubleTitle' | dbText}}</div>
          <div class="db-login-2fa-footer-text-desc">{{'text_disable2faTroubleDesc' | dbText}}</div>
        </div>
      </div>
      <div *ngIf="activeBlock === 'google-recovery'" (click)="changeBlock()">
        <div class="db-login-2fa-footer-image">
          <img class="db-icon-google-authenticator" src="assets/images/google/google-authenticator.svg" alt=""/>
        </div>
        <div class="db-login-2fa-footer-text">
          <div class="db-login-2fa-footer-text-title">{{'text_disable2faVerifTitle' | dbText}}</div>
          <div class="db-login-2fa-footer-text-desc">{{'text_disable2faVerifDesc' | dbText}}</div>
        </div>
      </div>
    </div>
</div>
